<ion-header class="remove-margin-from-safe-area ion-no-border">
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-toolbar>
                        <ion-buttons slot="end">
                            <ion-button (click)="onCancelModal()"
                            >
                                <ion-icon color="dark" name="close"></ion-icon
                                >
                            </ion-button>
                        </ion-buttons>
                    </ion-toolbar>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col style="text-align: center;">
                    <h2 class="subheader-regular">{{ violation['Ticket']}}</h2>
                </ion-col>
            </ion-row>
        </ion-grid>


    </ion-toolbar>
</ion-header>


<ion-content>

    <ion-card class="card-shadow-7 single-col-wider">
        <ion-grid *ngIf="violation">
            <ion-row>
                <ion-col style="text-align: center;">
                    <ion-chip style="font-weight: bold;"
                              color="primary"
                              *ngIf="violation['appealType'] == appealsSRV.appealTypes.reduced"
                    >{{ ('keys.data.violations.reduced' | translate : {Default: 'Reduced'})
                    || "Reduced"}}</ion-chip
                    >
                    <ion-chip style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;"
                              *ngIf="violation['appealType'] == appealsSRV.appealTypes.cancelled"
                    >{{ ('keys.data.violations.cancelled' | translate : {Default: 'Cancelled'})
                    || "Cancelled"}}</ion-chip
                    >
                    <ion-chip style="font-weight: bold;"
                              color="danger"
                              *ngIf="violation['appealType'] == appealsSRV.appealTypes.denied"
                    >{{ ('keys.data.violations.upheld' | translate : {Default: 'Upheld'}) || "Upheld"}}</ion-chip
                    >
                    <ion-chip
                            style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;"
                            *ngIf="violation['payID'] && violation['appealType'] !== appealsSRV['appealTypes'].cancelled"
                    >{{ ('keys.data.violations.already_paid' | translate : {Default: 'Already Paid'})
                    || "Already Paid"}}</ion-chip
                    >
                    <ion-chip
                            style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;"
                            *ngIf="violation['timeLeft'] && violation['appealType'] !== appealsSRV['appealTypes'].cancelled"
                    >
                        <ion-label
                                class="ion-text-wrap"
                                *ngIf="violation['timeLeft']['days']>0"
                        >{{violation['timeLeft']['days']}} {{ ('keys.data.violations.days_left' |
                            translate : {Default: 'Days Left'}) || 'Days Left' }}</ion-label
                        >
                        <ion-label
                                class="ion-text-wrap"
                                *ngIf="violation['timeLeft']['days']<=0 && violation['timeLeft']['hours']>0 "
                        >{{violation['timeLeft']['hours']}}  {{ ('keys.data.violations.hours_left' |
                            translate : {Default: 'Hours Left'}) || 'Hours Left' }}</ion-label
                        >
                        <ion-label
                                class="ion-text-wrap"
                                *ngIf="violation['timeLeft']['days']<=0 && violation['timeLeft']['hours']<=0 "
                        >{{violation['timeLeft']['minutes']}} {{ ('keys.data.violations.minutes_left' |
                            translate : {Default: 'Minutes Left'}) || 'Minutes Left' }}</ion-label
                        >
                    </ion-chip
                    >
                    <ion-chip style="font-weight: bold;" *ngIf="!violation['timeLeft'] && !violation['payID']" color="danger"
                    >
                        <ion-label>Past Due</ion-label>
                    </ion-chip>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="ion-no-padding">
                    <swiper #swiper [config]="config">
                        <ng-template
                                swiperSlide
                                *ngFor="let image of violation['attachments']"
                        >
                            <ion-grid class="ion-no-padding">
                                <ion-row>
                                    <ion-col class="ion-no-padding" size="2">
                                        <ion-button
                                                color="dark"
                                                fill="clear"
                                                class="swiper-button-prev"
                                                style="height: 100%; display: block"
                                        >
                                            <ion-icon name="chevron-back"></ion-icon
                                            >
                                        </ion-button>
                                    </ion-col>
                                    <ion-col style="height: 100%" class="ion-no-padding" size="8">
                                        <img [src]="image['fileLocation']"/>
                                    </ion-col>
                                    <ion-col class="ion-no-padding" size="2">
                                        <ion-button
                                                color="dark"
                                                fill="clear"
                                                class="swiper-button-next"
                                                style="height: 100%; display: block"
                                        >
                                            <ion-icon name="chevron-forward"></ion-icon
                                            >
                                        </ion-button>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ng-template>
                    </swiper>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="12">
                    <ion-item lines="none" *ngIf="violation['Plate']!=''">
                        <ion-label class="paragraph-input-fields-bold"> {{('keys.data.vehicles.plate' | translate : {Default: 'Plate'}) || 'Plate'}} </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">{{violation['Plate']}}</span>
                    </ion-item>
                    <ion-item lines="none" *ngIf="violation['ProvName']!=null">
                        <ion-label class="paragraph-input-fields-bold">  {{ ('keys.data.common.province_or_state' | translate : {Default: 'Province or State'})
                        || "Province or State"}} </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">{{violation['ProvName']}}</span>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label class="paragraph-input-fields-bold"> {{('keys.data.violations.writer' | translate : {Default: 'Writer'}) || 'Writer'}} </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">{{violation['Writer']}}</span>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label class="paragraph-input-fields-bold"> {{('keys.data.violations.issued' | translate : {Default: 'Issued'}) || 'Issued'}} </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">
              {{violation['Issued'] | date:dataService.settings['system']['datemask']}}</span>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label class="paragraph-input-fields-bold">
                            {{('keys.data.violations.due' | translate : {Default: 'Due'}) || 'Due'}}
                        </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">
              {{violation['Due'] | date:dataService.settings['system']['datemask']}}</span>
                    </ion-item>
                    <ion-item lines="none" *ngIf="violation?.Comment">
                        <ion-label class="paragraph-input-fields-bold">
                            {{('keys.data.admin_common.comment' | translate : {Default: 'Comment'}) || 'Comment'}}
                        </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">
              {{violation?.Comment}}</span>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label class="paragraph-input-fields-bold">{{('keys.data.common.ticket_type' | translate : {Default: 'Ticket Type'}) || 'Ticket Type'}} </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">{{violation['TicketTypeName']}}</span>
                    </ion-item>
                    <ion-item lines="none" style="border-bottom: 0.1em rgba(0, 0, 0, 0.302) solid">
                        <ion-label class="paragraph-input-fields-bold">{{('keys.data.violations.location' | translate : {Default: 'Location'}) || 'Location'}} </ion-label>
                        <span class="ion-text-right paragraph-input-fields-regular">{{violation['LocationName']}}</span>
                    </ion-item>

                    <ion-item lines="none" class="paragraph-input-fields-regular" *ngFor="let detail of violation['details'];">
                        <ion-label class="ion-text-wrap" slot="start"
                        >{{detail.ViolationDescr}}</ion-label
                        >
                        <ion-label
                                [ngStyle]="{'text-decoration':appealsSRV.isCancelled(violation['appealType'])}"
                                class="ion-text-right ion-text-wrap"
                                color="danger"
                        >{{detail.offenceFine | currency}}</ion-label
                        >
                    </ion-item>
                    <ion-item lines="none" lines="none">
                        <ion-label class="ion-text-wrap" slot="start"
                        >{{ ('keys.data.violations.adjustment' |
                            translate : {Default: 'Adjustment'}) || 'Adjustment' }}</ion-label
                        >
                        <ion-label
                                class="ion-text-right ion-text-wrap"
                        >{{violation['CalculatedFine'].adjustment |
                            currency}}</ion-label
                        >
                    </ion-item>
                    <ion-item lines="none"
                              class="paragraph-input-fields-bold"
                              lines="none"
                    >
                        <ion-label class="ion-text-wrap" slot="start">{{('keys.data.common.total' | translate : {Default: 'Total'}) || 'Total'}}</ion-label>
                        <ion-label
                                class="ion-text-wrap"
                                style="font-weight: bold"
                                class="ion-text-right"
                        >
                            {{violation['CalculatedFine'].finalTotal | currency}}</ion-label
                        >
                    </ion-item>


                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-card>
                        <ion-accordion-group *ngIf="violation['AppealUserID'] !== 0">
                            <ion-accordion>
                                <ion-item lines="none" slot="header">
                                    <ion-label> {{('keys.data.violations.show_appeal_information' | translate : {Default: 'Show Appeal Information'}) || 'Show Appeal Information'}} </ion-label>
                                    <ion-badge
                                            color="primary"
                                            *ngIf="violation['appealType'] == appealsSRV.appealTypes.reduced"
                                    >{{ ('keys.data.violations.reduced' |
                                        translate : {Default: 'Reduced'}) || "Reduced"}}</ion-badge
                                    >
                                    <ion-badge
                                            color="success"
                                            *ngIf="violation['appealType'] == appealsSRV.appealTypes.cancelled"
                                    >{{ ('keys.data.violations.cancelled' |
                                        translate : {Default: 'Cancelled'}) || "Cancelled"}}</ion-badge
                                    >
                                    <ion-badge
                                            color="danger"
                                            *ngIf="violation['appealType'] == appealsSRV.appealTypes.denied"
                                    >{{ ('keys.data.violations.upheld' | translate : {Default: 'Upheld'}
                                    ) || "Upheld"}}</ion-badge
                                    >
                                </ion-item>

                                <div slot="content">
                                    <ion-grid>
                                        <!-- Row 1: Appeal Reason -->
                                        <ion-row class="ion-align-items-start">
                                            <ion-col size="4" class="label-col">
                                                <strong>
                                                    {{ 'keys.data.violations.user_appeal_comment' | translate : {Default: 'Appeal Reason'} }}:
                                                </strong>
                                            </ion-col>
                                            <ion-col size="8" class="text-col">
                                                {{ violation['AppealComment'] }}
                                            </ion-col>
                                        </ion-row>

                                        <ion-row class="ion-align-items-start">
                                            <ion-col size="4" class="label-col">
                                                <strong>
                                                    {{ 'keys.data.violations.supporting_evidence' | translate : {Default: 'Supporting Evidence'} }}:
                                                </strong>
                                            </ion-col>

                                            <ion-col size="8" class="text-col">
                                                <ion-list>
                                                    <ion-item *ngFor="let image of violation.decodedEvidence">
                                                        <ion-thumbnail slot="start">
                                                            <ion-img *ngIf="image.attachExt!='pdf'" [src]="image.baseDomain+image.storageLocation"></ion-img>
                                                            <ion-img *ngIf="image.attachExt=='pdf'" src="assets/images/document.svg "></ion-img>
                                                        </ion-thumbnail>

                                                        <ion-label class="ion-text-wrap">
                                                            <ion-button size="small" style="--padding-start: 6px; --padding-end: 6px; --padding-top: 4px; --padding-bottom: 4px; font-size: 12px; height: 28px;" (click)="openLink(image.baseDomain+image.storageLocation)">
                                                                {{ 'keys.data.common.view_information' | translate : {Default: 'View Info'} }}
                                                            </ion-button>
                                                        </ion-label>
                                                    </ion-item>
                                                </ion-list>
                                            </ion-col>
                                        </ion-row>

                                        <!-- Row 2: Admin Response -->
                                        <ion-row class="ion-align-items-start">
                                            <ion-col size="4" class="label-col">
                                                <strong>
                                                    {{ 'keys.data.violations.admin_response' | translate : {Default: 'Admin Response'} }}:
                                                </strong>
                                            </ion-col>
                                            <ion-col size="8" class="text-col">
                                                <ng-container *ngIf="violation['AppealAdminComment']; else noResponse">
                                                    {{ violation['AppealAdminComment'] }}
                                                </ng-container>
                                                <ng-template #noResponse>
                                                    <ion-chip>
                                                        {{ 'keys.data.violations.no_response_yet' | translate : {Default: 'No Response Yet.'} }}
                                                    </ion-chip>
                                                </ng-template>
                                            </ion-col>
                                        </ion-row>
                                    </ion-grid>
                                </div>

                            </ion-accordion>
                        </ion-accordion-group>
                    </ion-card>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col style="text-align: center;">
                    <ion-button
                            [disabled]="!violation['timeLeft'] || violation['payID'] || violation['AppealUserID'] !==0"

                            color="secondary"
                            (click)="appealsSRV.openRequestAppealModal(violation)"
                    >
                        {{ ('keys.data.violations.request_appeal' | translate : {Default: 'Request Appeal'})
                    || "Request Appeal"}}

                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>

</ion-content>

